const axios = require('axios');
const tailwindTheme = require('../../tailwind.config.js');
const defaultTailwindTheme = require('tailwindcss/defaultTheme');

const contentful_access_token = process.env.GATSBY_CONTENTFULL_TOKEN;
const contentful_space = process.env.GATSBY_CONTENTFULL_SPACE_ID;
const contentful_environment = process.env.GATSBY_CONTENTFULL_ENVIRONMENT;
const contentful_api_base = `https://cdn.contentful.com/spaces/${contentful_space}/environments/${contentful_environment}`;
const contentful_api_base_url = `${contentful_api_base}/entries`;

// for build to limit error
const wait = async () =>
  new Promise((res) => {
    setTimeout(res, 500);
  });
const getContentfulItems = async (query, type) => {
  let limit = 800;
  let items = [];

  await wait();
  const contentfulResponse = await axios.get(
    `${contentful_api_base_url}?access_token=${contentful_access_token}&include=4&content_type=${type}`
  );

  const total = contentfulResponse.data.total;

  for (let i = 0; i < total; i += limit) {
    await wait();
    const response = await axios.get(
      `${contentful_api_base_url}?access_token=${contentful_access_token}&include=4&content_type=${type}&skip=${i}&limit=${limit}`
    );
    items = items.concat(response.data.items);
  }

  if (query) {
    items = items.filter((item) =>
      item.fields.title.toLowerCase().includes(query.toLowerCase())
    );
  }

  return items.map((slug) => ({
    id: slug.sys.id,
    title: slug.fields.title,
  }));
};

const fillFields = (entries, include) => {
  const includeMap = new Map();
  include.forEach((item) => {
    includeMap.set(item.sys.id, item.fields);
  });

  function processFields(obj) {
    if (obj && typeof obj === 'object') {
      if (obj.sys && obj.sys.type === 'Link' && obj.sys.linkType === 'Entry') {
        const included = includeMap.get(obj.sys.id);
        if (included) {
          obj = included;
        }
      } else {
        Object.keys(obj).forEach((key) => {
          obj[key] = processFields(obj[key]);
        });
      }
    }
    return obj;
  }

  return entries.map((entry) => {
    const sys = { id: entry.sys.id };
    const fields = processFields(entry.fields);
    return { sys, fields };
  });
};
const getContentfulItemById = async (id) => {
  await wait();
  const contentfulResponse = await axios.get(
    `${contentful_api_base_url}/${id}?access_token=${contentful_access_token}`
  );

  if (!contentfulResponse.data) {
    throw new Error("can't find product");
  }

  return {
    id: contentfulResponse.data.sys.id,
    title: contentfulResponse.data.fields.title,
  };
};

const contentfulAssets = {
  fetch: async (resources) => {
    let limit = 800;
    let items = [];

    for (let i = 0; i < resources.length; ++i) {
      let resource = resources[i];

      await wait();
      const { data } = await axios.get(
        `${contentful_api_base}/assets/${resource.id}?access_token=${contentful_access_token}`
      );
      items.push({
        ...resource,
        type: 'asset',
        value: data || {},
      });
    }

    return items;
  },
  getItems: async (query) => {
    let limit = 800;
    let items = [];

    await wait();
    const contentfulResponse = await axios.get(
      `${contentful_api_base}/assets?access_token=${contentful_access_token}`
    );

    items = items.concat(contentfulResponse.data.items);
    const total = contentfulResponse.data.total;

    for (let i = 0; i < total; i += limit) {
      await wait();
      const response = await axios.get(
        `${contentful_api_base}/assets?access_token=${contentful_access_token}&skip=${i}&limit=${limit}`
      );
      items = items.concat(response.data.items);
    }

    if (query) {
      items = items.filter((item) =>
        item.fields.title.toLowerCase().includes(query.toLowerCase())
      );
    }

    return items.map((i) => ({
      id: i.sys.id,
      title: i.fields.title,
      thumbnail: i.fields?.file?.details?.image
        ? i.fields.file?.url
        : undefined,
    }));
  },
  getItemById: async (id) => {
    await wait();
    const contentfulResponse = await axios.get(
      `${contentful_api_base}/assets/${id}?access_token=${contentful_access_token}`
    );
    if (!contentfulResponse.data) {
      throw new Error("can't find product");
    }

    return {
      id: contentfulResponse.data.sys.id,
      title: contentfulResponse.data.fields.title,
      thumbnail: contentfulResponse.data.fields?.file?.details?.image
        ? contentfulResponse.data.fields.file?.url
        : undefined,
    };
  },
};
const fetchContentfulEntry = async (resources, type, params, depth = 4) => {
  let limit = 800;
  let items = [];

  if (['icon', 'label'].includes(type)) {
    await wait();
    const response = await axios.get(
      `${contentful_api_base_url}?access_token=${contentful_access_token}&include=${depth}&content_type=${type}&locale=${
        params.locale
      }&sys.id[in]=${resources.map((r) => r.id).join(',')}`
    );
    items = fillFields(
      response.data.items,
      response.data.includes?.Entry || []
    );
  } else {
    await wait();
    const contentfulResponse = await axios.get(
      `${contentful_api_base_url}?access_token=${contentful_access_token}&include=${depth}&content_type=${type}&locale=${params.locale}`
    );

    const total = contentfulResponse.data.total;

    for (let i = 0; i < total; i += limit) {
      await wait();
      const response = await axios.get(
        `${contentful_api_base_url}?access_token=${contentful_access_token}&include=${depth}&content_type=${type}&skip=${i}&limit=${limit}&locale=${params.locale}`
      );
      items = items.concat(response.data.items);
    }
  }

  const r = resources.map((resource) => ({
    ...resource,
    type: type,
    value: items.find((item) => item.sys.id === resource.id)?.fields,
  }));
  return r;
};

const shopstoryProductFetch = async (resources, type, params) => {
  let items = [];
  for (let i = 0; i < resources.length; i++) {
    const response = await axios
      .get(`${process.env.GATSBY_NOOZ_API_URL}/products/${resources[i].id}`, {
        headers: {
          locale: params.locale,
          'contentful-env': process.env.GATSBY_CONTENTFULL_ENVIRONMENT,
          zone: process.env.GATSBY_ZONE,
        },
      })
      .catch((err) => {
        console.log(err);
      });
    items.push(response.data[0]);
  }

  return resources.map((resource, index) => ({
    ...resource,
    type: type,
    value: items[index],
  }));
};

const returnTailwindColors = () => {
  let colors = [];
  Object.keys(tailwindTheme.theme.colors).map((color) => {
    if (typeof tailwindTheme.theme.colors[color] === 'string') {
      colors.push({
        id: color,
        label: color,
        value: tailwindTheme.theme.colors[color],
      });
    } else {
      Object.keys(tailwindTheme.theme.colors[color]).map((c) => {
        colors.push({
          id: `${color}_${c}`,
          label: `${color}_${c}`,
          value: tailwindTheme.theme.colors[color][c],
        });
      });
    }
  });
  return colors;
};

const returnTailwindFonts = () => {
  const fonts = [];
  ['Gilmer', 'Inter'].forEach((font) =>
    Object.keys(defaultTailwindTheme.fontSize).map((size) => {
      ['normal', 'medium', 'bold'].forEach((weight) => {
        fonts.push({
          id: size.includes('xl')
            ? `heading_${size}_${font}_${weight}`
            : `body_${size}_${font}_${weight}`,
          label: size.includes('xl')
            ? `heading_${size}_${font}_${weight}`
            : `body_${size}_${font}_${weight}`,
          value: {
            fontSize: defaultTailwindTheme.fontSize[size][0],
            lineHeight: defaultTailwindTheme.fontSize[size][1].lineHeight,
            fontFamily: font,
            fontWeight: weight,
          },
        });
      });
    })
  );
  return fonts;
};

module.exports.contentfulAssets = contentfulAssets;
module.exports.contentful_access_token = contentful_access_token;
module.exports.contentful_space = contentful_space;
module.exports.contentful_api_base_url = contentful_api_base_url;
module.exports.getContentfulItems = getContentfulItems;
module.exports.getContentfulItemById = getContentfulItemById;
module.exports.fetchContentfulEntry = fetchContentfulEntry;
module.exports.shopstoryProductFetch = shopstoryProductFetch;
module.exports.returnTailwindColors = returnTailwindColors;
module.exports.returnTailwindFonts = returnTailwindFonts;
